import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import React, { useEffect, useState } from "react";
import PointerSvg from "@assets/pointer_1.svg";
import ScalaSvg from "@assets/tacho_scala_blue.svg";

interface GaugeProps {
  value: number;
  max: number;
  label: string;
  isElectric?: boolean;
}

const Gauge: React.FC<GaugeProps> = ({ value, max, label, isElectric }) => {
  const min = isElectric ? -max : 0
  const rotation = ((value - min) / (max - min)) * 270;
  const [currentValue, setCurrentValue] = useState(0);

  useEffect(() => {
    const duration = 4000;
    const steps = 50;
    const stepTime = duration / steps;

    let currentStep = 0;
    const increment = (value - currentValue) / steps;

    const interval = setInterval(() => {
      currentStep += 1;

      setCurrentValue(prev => {
        const newValue = prev + increment;
        if ((increment > 0 && newValue >= value) || (increment < 0 && newValue <= value)) {
          clearInterval(interval);
          return value;
        }
        return newValue;
      });

      if (currentStep >= steps) {
        clearInterval(interval);
      }
    }, stepTime);


    return () => clearInterval(interval);
  }, [value, currentValue]);
  return (
    <Tooltip title={value.toFixed(0) + " " + label}>
      <Box sx={{ position: "relative", width: "80%", height: "auto", aspectRatio: "1 / 1" }}>

        {/* Scala (Scale) */}
        <img
          src={ScalaSvg}
          alt="Scale"
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
          }}
        />

        {/* Pointer */}
        <img
          src={PointerSvg}
          alt="Pointer"
          style={{
            transform: `rotate(${rotation}deg)`,
            transition: 'transform 5s ease',
            width: "100%",
            height: "100%",
            position: "absolute",
            left: 0,
            top: 0
          }}
        />

        {/* Value and Label */}
        <Box
          sx={{
            position: "absolute",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%"
          }}
        >
          <Box sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly",
            alignItems: "center",
            width: "100%",
            height: "100%",
          }}>
            <Box style={{ fontSize: "calc(0.3rem + 1vw)" }}>{currentValue.toFixed(0)}</Box>
            <Box style={{ fontSize: "calc(0.3rem + 0.5vw)" }}>{label}</Box>
          </Box>
        </Box>
      </Box>
    </Tooltip>
  );
};

export default Gauge;
